import React from 'react';
import moment from "moment";
import {green500, grey500} from "material-ui/styles/colors";
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import Lens from "material-ui/svg-icons/image/lens";
import EventService from "core/event/eventService";
import {IDomainObject} from "core/form/formUtils";
import {ID} from "core/metamodel/metaConstant";
import MdEntity from "core/metamodel/mdEntity";
import {action} from "mobx";
import origin = __MaterialUI.propTypes.origin;
import CSSProperties = React.CSSProperties;
import {observer} from "mobx-react";
import {WithActive} from "core/event/eventDomain";

const __anchorOrigin: origin = {horizontal: 'left', vertical: 'top'};
const iconButton__style = {width: 32, height: 32, padding: "0 8px 0 0"};

export const StatusActiveComp__h5_style: CSSProperties = {margin: 0, lineHeight: '32px', fontSize: '18px', fontWeight: 'bold'};

interface StatusActiveCompProps {
  activeObject?: IDomainObject;
  id?: ID;
  entity?: MdEntity
}

@observer
export class StatusActiveComp extends React.Component<StatusActiveCompProps, undefined> {

  @action onClose = () => {
    let {activeObject, entity, id} = this.props;
    console.log('onClose');
    ((activeObject.$new) ? Promise.resolve({active: false, closeDate: moment().startOf("day").toDate()}) : EventService.closeObject(entity, id))
      .then(action("onClose-handler", (data: WithActive) => {
        activeObject.active = data.active;
        activeObject.closeDate = data.closeDate;
      }));
  };

  @action onOpen = () => {
    let {activeObject, entity, id} = this.props;
    console.log('onOpen');
    ((activeObject.$new) ? Promise.resolve({active: true}) : EventService.openObject(entity, id))
      .then(action("onOpen-handler", (data: WithActive) => {
        activeObject.active = data.active;
        activeObject.closeDate = data.closeDate;
      }));
  };

  render() {
    const {activeObject, ...other} = this.props;


    return (
      <IconMenu iconButtonElement={<IconButton style={iconButton__style} iconStyle={{color: activeObject.active ? green500 : grey500}}>
        <Lens/>
      </IconButton>}
                anchorOrigin={__anchorOrigin}
                targetOrigin={__anchorOrigin}>
        { (activeObject.active) ? <MenuItem primaryText="Close" onClick={this.onClose}/> : <MenuItem primaryText="Open" onClick={this.onOpen}/> }
      </IconMenu>
    );


  }

}



// WEBPACK FOOTER //
// ./src/core/components/buttons/statusActiveComp.tsx